import React, { useEffect, useReducer, useState } from "react";
import { api, constants } from "../../../utils";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGfm from "remark-gfm";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import _ from "lodash";
import toast from "react-hot-toast";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formReducer } from "../../../utils/stateHandlers/reducers";
import states from "../../../utils/stateHandlers/initialStates";
import { FormContext } from "../../../utils/stateHandlers/contexts";

const schema = yup.object().shape({
  // category: yup
  //   .string()
  //   .test(
  //     "category-not-selected",
  //     "Please Select the Category",
  //     (value) => value !== "None"
  //   )
  //   .required("Please Select the Category"),
  // company_name: yup.string().required("Please Enter Your Company Name"),
  // first_name: yup.string().required("Please Enter Your First Name"),
  // last_name: yup.string().required("Please Enter Your Last Name"),
  // email: yup.string().required("Please Enter Your Email"),
  // phone: yup.string().required("Please Enter Your Phone Number"),
  // message: yup.string().required("Please Type A Message"),
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const initialAuthBuyerFields = [
  {
    id: 1,
    fields: [
      {
        value: "",
        label: "Name",
        name: "Name",
      },
      {
        value: "",
        label: "Phone # / Ext",
        name: "Phone",
      },
      {
        value: "",
        label: "Email",
        name: "Email",
      },
    ],
  },
];

export default function Net30Form(props) {
  const [formState, dispatch] = useReducer(formReducer, states);
  const { isLoaded, fields, formtext, formtitle, submitted, formInfo } =
    formState;
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [startDate, setStartDate] = useState(new Date());
  const [authorizedBuyers, setAuthorizedBuyers] = useState([]);
  const [authorizedBuyersFields, setAuthorizedBuyersFields] = useState(
    initialAuthBuyerFields
  );
  const [tradeReferences, setatradeReferences] = useState([]);
  const [tradeReferencesFields, setTradeReferencesFields] = useState([]);

  const DateField = (field) => (
    <Stack sx={{ margin: "1rem" }}>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
      </Typography>
      <span style={{ border: "1px solid #939598", padding: "0.3rem" }}>
        <DatePicker
          {...register(field.name)}
          error={errors[field.name] ? true : false}
          helperText={errors[field.name] ? errors[field.name].message : ""}
          selected={startDate}
          onChange={(date) => setStartDate(date)}
        />
      </span>
    </Stack>
  );

  const InputField = (field) => (
    <Stack sx={{ margin: "1rem" }}>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
      </Typography>
      <TextField
        {...register(field.name)}
        error={errors[field.name] ? true : false}
        helperText={errors[field.name] ? errors[field.name].message : ""}
        color="primary"
        size="small"
        defaultValue={field.default ? field.default : ""}
        sx={{
          width: "100%",
          margin: "unset",
        }}
      />
    </Stack>
  );

  const InputAreaField = (field) => (
    <Stack>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
      </Typography>
      <TextField
        {...register(field.name)}
        error={errors[field.name] ? true : false}
        helperText={errors[field.name] ? errors[field.name].message : ""}
        multiline
        fullWidth
        defaultValue={field.default ? field.default : ""}
        rows={3}
        sx={{
          width: "100%",
          margin: "unset",
        }}
      />
    </Stack>
  );

  const SelectField = (field) => (
    <Stack sx={{ margin: "1rem" }}>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
      </Typography>
      <FormControl
        {...register(field.name)}
        error={errors[field.name] ? true : false}
      >
        <Select
          key={field.name}
          defaultValue={field.default ? field.default : "None"}
          size="small"
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #939598",
                borderRadius: "0",
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              },
            },
          }}
          onChange={(e) =>
            setValue(field.name, e.target.value, { shouldValidate: true })
          }
        >
          <MenuItem value="None">
            <em>Select...</em>
          </MenuItem>
          {field.values.map((option) => (
            <MenuItem value={option.value} key={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>
          {errors[field.name] ? errors[field.name].message : ""}
        </FormHelperText>
      </FormControl>
    </Stack>
  );

  const RadioButtonField = (field) => (
    <FormControl
      sx={{ margin: "1rem" }}
      {...register(field.name)}
      error={errors[field.name] ? true : false}
      onChange={(e) =>
        setValue(field.name, e.target.value, { shouldValidate: true })
      }
    >
      <FormLabel>
        <Typography
          sx={{ fontWeight: "700", paddingBottom: ".3rem", color: "black" }}
        >
          {field.label} *
        </Typography>
      </FormLabel>
      <RadioGroup
        sx={{
          paddingLeft: "2rem",
          border: errors[field.name] ? "1px solid #954738" : "",
        }}
      >
        {field.values &&
          field.values.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={<Typography>{option.label}</Typography>}
            />
          ))}
      </RadioGroup>
      <FormHelperText>
        {errors[field.name] ? errors[field.name].message : ""}
      </FormHelperText>
    </FormControl>
  );

  const CheckboxField = (field) => (
    <FormControl
      {...register(field.name)}
      error={errors[field.name] ? true : false}
      onChange={(e) => {
        setValue(field.name, e.target.checked, {
          shouldValidate: true,
        });
      }}
    >
      <FormGroup>
        <FormControlLabel
          sx={{
            margin: "1rem",
            border: errors[field.name] ? "1px solid #954738" : "",
          }}
          label={<Typography variant="cellFont">{field.label}</Typography>}
          control={<Checkbox />}
        />
      </FormGroup>
      <FormHelperText>
        {errors[field.name] ? errors[field.name].message : ""}
      </FormHelperText>
    </FormControl>
  );

  function addAuthBuyerField() {
    let largestIdField = _.maxBy(authorizedBuyersFields, function (abf) {
      return abf.id;
    });
    console.log(largestIdField);
    let newFieldSet = [
      {
        id: largestIdField.id + 1,
        fields: [
          {
            value: "",
            label: "Name",
            name: "Name",
          },
          {
            value: "",
            label: "Phone # / Ext",
            name: "Phone",
          },
          {
            value: "",
            label: "Email",
            name: "Email",
          },
        ],
      },
    ];
    setAuthorizedBuyersFields(_.concat(authorizedBuyersFields, newFieldSet));
  }

  function removeAuthBuyersField(id) {
    const newSet = _.filter(authorizedBuyersFields, function (abf) {
      return abf.id !== id;
    });
    setAuthorizedBuyersFields(newSet);
  }

  const authorizedBuyersMultiField = (field) => (
    <>
      <Typography variant="h6">
        {field.label}{" "}
        <IconButton
          onClick={() => addAuthBuyerField()}
          color="success"
          sx={{
            width: "unset",
          }}
        >
          <AddIcon />
        </IconButton>
      </Typography>
      {authorizedBuyersFields &&
        authorizedBuyersFields.map((abf, index) => (
          <Stack direction="row" alignItems="center" key={index}>
            <IconButton
              onClick={() => removeAuthBuyersField(abf.id)}
              color="primary"
              sx={{
                width: "unset",
              }}
            >
              <CloseIcon />
            </IconButton>
            {abf.fields &&
              abf.fields.map((field) => (
                <Stack sx={{ margin: "1rem" }}>
                  <Typography
                    sx={{ fontWeight: "700", paddingBottom: ".3rem" }}
                  >
                    {field.label}
                  </Typography>
                  <TextField
                    {...register(`${field.name}${field.id}`)}
                    error={errors[`${field.name}${field.id}`] ? true : false}
                    helperText={
                      errors[`${field.name}${field.id}`]
                        ? errors[`${field.name}${field.id}`].message
                        : ""
                    }
                    color="primary"
                    size="small"
                    //value={field.value}
                    sx={{
                      width: "100%",
                      margin: "unset",
                    }}
                  />
                </Stack>
              ))}
          </Stack>
        ))}
    </>
  );

  const AddressBlock = (addressFields) => {
    return (
      <Stack>
        {addressFields.map((addressField) => (
          <>
            {(_.endsWith(addressField.name, "Street") ||
              _.endsWith(addressField.name, "Street1") ||
              _.endsWith(addressField.name, "Street2")) &&
              InputField(addressField)}
          </>
        ))}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              sm: "repeat(1, 1fr)",
              md: "repeat(2, 1fr)",
              lg: "repeat(2, 1fr)",
              xl: "repeat(2, 1fr)",
            },
          }}
        >
          {addressFields.map((addressField) => (
            <React.Fragment key={addressField.name}>
              {!(
                _.endsWith(addressField.name, "Street") ||
                _.endsWith(addressField.name, "Street1") ||
                _.endsWith(addressField.name, "Street2")
              ) &&
                (addressField.template === "text"
                  ? InputField(addressField)
                  : addressField.template === "dropdown"
                  ? SelectField(addressField)
                  : CheckboxField(addressField))}
            </React.Fragment>
          ))}
        </Box>
      </Stack>
    );
  };

  const submitApplication = (data) => {
    console.log(data);
    // const token = captchaRef.current.getValue();
    // const formData = {
    //   ...data,
    //   BypassRecaptcha: true,
    //   "g-recaptcha-response": token,
    // };
    // api.post("createaccount/create", formData).then((response) => {
    //   if (response.isAxiosError) {
    //     const errorMessage = [];
    //     _.forEach(response.response.data.errors, function (error) {
    //       errorMessage.push(error);
    //     });
    //     console.log(errorMessage);
    //     toast.error(
    //       `There was an error processing your request. ${_.toString(
    //         errorMessage
    //       )}`
    //     );
    //   } else {
    //     createAccountDispatch({
    //       type: "setAccountCreated",
    //       payload: true,
    //     });
    //   }
    // });
  };

  function sortFields(fields) {
    const applicantFields = [];
    const applicantAddressFields = [];
    const businessFields = [];
    const bankFields = [];
    const bankAddressFields = [];
    const generalFields = [];
    const vastFields = [];
    _.forEach(fields, function (field) {
      if (_.includes(constants.Net30ApplicantFields, field.name)) {
        applicantFields.push(field);
      } else if (
        _.includes(constants.Net30ApplicantAddressFields, field.name)
      ) {
        applicantAddressFields.push(field);
      } else if (_.includes(constants.Net30BusinessInfoFields, field.name)) {
        businessFields.push(field);
      } else if (_.includes(constants.Net30BankingInfoFields, field.name)) {
        bankFields.push(field);
      } else if (_.includes(constants.Net30BankAddressFields, field.name)) {
        bankAddressFields.push(field);
      } else if (_.includes(constants.Net30GeneralFields, field.name)) {
        generalFields.push(field);
      } else if (_.includes(constants.Net30VastFields, field.name)) {
        vastFields.push(field);
      }
    });
    const newlySortedFields = {
      applicantFields: applicantFields,
      applicantAddressFields: applicantAddressFields,
      businessFields: businessFields,
      bankFields: bankFields,
      bankAddressFields: bankAddressFields,
      generalFields: generalFields,
      vastFields: vastFields,
    };
    console.log(newlySortedFields);
    return newlySortedFields;
  }

  useEffect(() => {
    api.fetch(`forms/credit/fields`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
      } else {
        let formInfoPromise = new Promise((resolve, reject) => {
          resolve(
            _.forEach(response.data.fields, function (field) {
              dispatch({
                type: "updateFormInfo",
                field: field.name,
                payload: field.default,
              });
            })
          );
        });
        formInfoPromise
          .then(() => {
            const sortedFields = sortFields(response.data.fields);
            dispatch({ type: "setFields", payload: sortedFields });
          })
          .then(() => {
            dispatch({ type: "setIsLoaded", payload: true });
          });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api.fetchStrapi(`/forms/10?populate=*`).then((response) => {
      dispatch({
        type: "setFormCopy",
        payload: {
          formtitle: response.data.data.attributes.formtitle,
          formtext: response.data.data.attributes.formtext,
        },
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormContext.Provider value={{ formState, dispatch }}>
      {!isLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container>
          {!submitted ? (
            <form onSubmit={handleSubmit(submitApplication)}>
              <Stack spacing={3} sx={{ marginBottom: "3rem" }}>
                <Typography variant="articleTitle">{formtitle}</Typography>
                <Typography variant="staticText" sx={{ paddingBottom: "1rem" }}>
                  <ReactMarkdown
                    children={formtext}
                    remarkPlugins={[remarkGfm]}
                  />
                </Typography>
                <Typography variant="h6">Applicant Information</Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      sm: "repeat(1, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(2, 1fr)",
                      xl: "repeat(2, 1fr)",
                    },
                  }}
                >
                  {fields.applicantFields &&
                    fields.applicantFields.map((field) => (
                      <React.Fragment key={field.name}>
                        {field.template === "text"
                          ? InputField(field)
                          : field.template === "Phone" ||
                            field.template === "Fax"
                          ? InputField(field)
                          : field.template === "dropdown"
                          ? SelectField(field)
                          : field.template === "radio"
                          ? RadioButtonField(field)
                          : field.template === "textarea"
                          ? InputAreaField(field)
                          : field.template === "date"
                          ? DateField(field)
                          : CheckboxField(field)}
                      </React.Fragment>
                    ))}
                </Box>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      sm: "repeat(1, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(2, 1fr)",
                      xl: "repeat(2, 1fr)",
                    },
                  }}
                >
                  {AddressBlock(fields.applicantAddressFields)}
                </Box>
                <Divider flexItem />
                <Typography variant="h6">Business Information</Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      sm: "repeat(1, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(2, 1fr)",
                      xl: "repeat(2, 1fr)",
                    },
                  }}
                >
                  {fields.businessFields &&
                    fields.businessFields.map((field) => (
                      <React.Fragment key={field.name}>
                        {field.name !== "Officers" &&
                          (field.template === "text"
                            ? InputField(field)
                            : field.template === "Phone" ||
                              field.template === "Fax"
                            ? InputField(field)
                            : field.template === "dropdown"
                            ? SelectField(field)
                            : field.template === "radio"
                            ? RadioButtonField(field)
                            : field.template === "textarea"
                            ? InputAreaField(field)
                            : field.template === "date"
                            ? DateField(field)
                            : CheckboxField(field))}
                      </React.Fragment>
                    ))}
                </Box>
                {fields.businessFields &&
                  fields.businessFields.map((field) => (
                    <React.Fragment key={field.name}>
                      {field.name === "Officers" &&
                        authorizedBuyersMultiField(field)}
                    </React.Fragment>
                  ))}
                <Divider flexItem />
                <Typography variant="h6">Banking Information</Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      sm: "repeat(1, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(2, 1fr)",
                      xl: "repeat(2, 1fr)",
                    },
                  }}
                >
                  {fields.bankFields &&
                    fields.bankFields.map((field) => (
                      <React.Fragment key={field.name}>
                        {field.template === "text"
                          ? InputField(field)
                          : field.template === "Phone" ||
                            field.template === "Fax"
                          ? InputField(field)
                          : field.template === "dropdown"
                          ? SelectField(field)
                          : field.template === "radio"
                          ? RadioButtonField(field)
                          : field.template === "textarea"
                          ? InputAreaField(field)
                          : field.template === "date"
                          ? DateField(field)
                          : CheckboxField(field)}
                      </React.Fragment>
                    ))}
                </Box>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      sm: "repeat(1, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(2, 1fr)",
                      xl: "repeat(2, 1fr)",
                    },
                  }}
                >
                  {AddressBlock(fields.bankAddressFields)}
                </Box>
                <Divider flexItem />
                <Typography variant="h6">General Information</Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      sm: "repeat(1, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(2, 1fr)",
                      xl: "repeat(2, 1fr)",
                    },
                  }}
                >
                  {fields.generalFields &&
                    fields.generalFields.map((field) => (
                      <React.Fragment key={field.name}>
                        {field.template === "text"
                          ? InputField(field)
                          : field.template === "Phone" ||
                            field.template === "Fax"
                          ? InputField(field)
                          : field.template === "dropdown"
                          ? SelectField(field)
                          : field.template === "radio"
                          ? RadioButtonField(field)
                          : field.template === "textarea"
                          ? InputAreaField(field)
                          : field.template === "date"
                          ? DateField(field)
                          : CheckboxField(field)}
                      </React.Fragment>
                    ))}
                </Box>
                <Button
                  color="success"
                  variant="contained"
                  type="submit"
                  sx={{ width: "25%" }}
                >
                  Submit Credit Application
                </Button>
              </Stack>
            </form>
          ) : (
            <Paper variant="outlined" sx={{ padding: "2rem" }}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  Your Application is Getting Sent to our Financial Coordinator.
                </Typography>
                <Typography>
                  We are here to help you via phone Monday-Friday 9AM - 5:30PM
                  EDT. Please call 800-759-9997 toll-free. Outside the U.S. and
                  Canada, call 001.804.794.1118.
                </Typography>
                <Typography>
                  Or email us ANYTIME at info@hooverandstrong.com. It is our
                  goal to respond to your email within one business day.
                </Typography>
              </Stack>
            </Paper>
          )}
        </Container>
      )}
    </FormContext.Provider>
  );
}
